export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Our Business',
    headline: 'Locally Owned',
    description: 'Smith Mountain Laundromat has been serving the community with a clean and efficient place to wash since 1991. As a locally owned and operated small business, we pride ourselves in offering quality and affordable laundry services as well as a clean and comfortable environment.',
    imgStart: false,
    img: require('../../images/local.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'services',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topline: 'Our Machines',
    headline: 'Gas-burning Dryers',
    description: 'Offering High Capacity Front load commercial grade washers for your comforters and quilts, all the way down to simple single basket top load machines, we offer all types of wash options to best suit your needs. Opting to keep our “Classic” Extra-Large Gas burning dryers, our dryers offer a higher drying temperature than our competitors, a true customer favorite.',
    imgStart: true,
    img: require('../../images/fire.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: true
};

export const homeObjThree = {
    id: 'safety',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Safety',
    headline: 'High Security',
    description: 'With "State of the Art" security in place, whether you are washing alone, with your family, or late in the evening, our facility is well-lit and closely monitored to ensure your safety at all times.',
    imgStart: false,
    img: require('../../images/secure.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjFour = {
    id: 'sanitation',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topline: 'Cleanliness',
    headline: 'Cleaned Daily',
    description: 'Our top priority! We feel that any customers experience is enhanced by knowing that they are washing their laundry in a clean facility, which is why we do our absolute best to stay on top of cleaning schedules and sanitation.',
    imgStart: true,
    img: require('../../images/clean.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: true
};

export const homeObjFive = {
    id: 'contact',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Contact',
    headline: '(540) 521-6141',
    description: 'Feel free to text us concerning mechanical issues, questions, or how we can continue improving your experience. If it is an emergency give us a call.',
    imgStart: false,
    img: require('../../images/contact.png'),
    alt: 'washer',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjSix = {
    id: 'location',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topline: 'Location',
    headline: 'Convenience',
    description: 'Located at the intersection of Rt 122 and Hendricks Store Rd, we are smack dab in the middle of Moneta, making your visit fast and easy while out running errands or shopping.',
    dark: true,
    primary: true,
    darkText: true
};

